import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import Navabar from './Components/Navbars/Navabar';
import Home from './Components/home/Home';
import Aboutme from './Components/aboutme/Aboutme';
import Product from './Components/product/Product';
import Team from './Components/team/Team';
import Contact from './Components/contact/Contact';
import Inf from './Components/inf/Inf';
import Footer from './Components/footer/Footer';
import Topbtn from './Components/Top scrol/Topbtn';
import Wttsep from './Components/Wattsep/Wttsep';


function App() {
  return (
    <>
     <div className='app'>
     <BrowserRouter >
        <Navabar />
        <Routes>
          <Route path="/" element={ <Home /> } />
          <Route path='/aboutme' element={ <Aboutme /> } />
          <Route path='/product' element={ <Product /> } />
          <Route path='/team' element={ <Team /> } />
          <Route path='/inf' element={ <Inf /> } />
          <Route path='/contact' element={ <Contact /> } />
        </Routes>
        <Wttsep/>
        <Topbtn/>
        <Footer />
      </BrowserRouter>
     </div>
    </>
  );
}

export default App;
